export const enum EIconsNames {
  BULB_ON,
  BURGER,
  CLOCK,
  CLOSE,
  CUP,
  FLAG,
  FREE,
  GIFT,
  PLANT,
  PURPOSE,
  RUBY,
  SHARE,
  STAR,
  THUMB_UP,
  WAND
}

export const enum EServerName {
  plug,
  beeline,
  tele2,
  altel,
  kcell
}

export enum ELang {
  kz = 'kz',
  ru = 'ru'
}
